import React from 'react';
import HundredPercentContainer from '../../core/common/HundredPercentContainer';
import MainSizer from '../../core/common/MainSizer';
import CookieBanner, { BANNER_HEIGHT } from './CookieBanner';
import './style/MainSizerWithBanner.scss';

export default class MainSizerWithBanner extends React.Component {
  render() {
    const { children, ...sizerProps } = this.props;

    if (sizerProps.minHeight) {
      const intHeight = parseInt(sizerProps.minHeight.split('px').join(''), 10);
      // Height also in this component's css for pseudo support
      sizerProps.minHeight = `${intHeight + BANNER_HEIGHT}px`;
    }

    return (
      <HundredPercentContainer>
        <MainSizer {...sizerProps}>
          <div className="MainSizerWithBanner__Content">
            {this.props.children}
          </div>
          <CookieBanner />
        </MainSizer>
      </HundredPercentContainer>
    );
  }
}
